import { isRSAA, RSAA } from 'redux-api-middleware'
import { Middleware, UnknownAction } from '@reduxjs/toolkit'
import { auth0Token } from 'common/utils/authUtils'

interface IReduxApiAction extends UnknownAction {
  [RSAA]: {
    headers: object
  }
}

const authTokenMiddleware: Middleware = () => (next) => (untypedAction) => {
  const unknownAction = untypedAction as UnknownAction

  if (!isRSAA(unknownAction)) {
    return next(unknownAction)
  }

  const action = unknownAction as IReduxApiAction

  return (async () => {
    const bearerToken = (await auth0Token.getAccessTokenSilently()) as string

    return next({
      ...action,
      [RSAA]: {
        ...action[RSAA],
        bailout: bearerToken == null,
        headers: {
          ...action[RSAA].headers,
          Authorization: `Bearer ${bearerToken}`
        }
      }
    })
  })()
}

export default authTokenMiddleware
